export default __webpack_public_path__ + "static/media/info3Logo1.33db0ba8.jpeg";